import React from 'react';
import SVGLoader from './SVGLoader';

const AviveStatusIcon = props => {
  const { width, height, viewboxWidth, viewboxHeight, ...rest } = props;

  return (
    <SVGLoader
      {...rest}
      width={width || 16}
      height={height || 14}
      viewboxWidth={viewboxWidth || 16}
      viewboxHeight={viewboxHeight || 14}
    >
      <path
        d="M14.0878 6.71868H10.8783C10.7543 6.71901 10.6422 6.79519 10.5926 6.91286L9.86823 8.59962C9.71897 8.94758 9.38708 9.17307 9.01943 9.17633H9.01006C8.64597 9.17548 8.31529 8.95644 8.16189 8.61451L6.84932 5.70896C6.82521 5.65617 6.7756 5.62085 6.71937 5.61643C6.66314 5.61202 6.60895 5.63919 6.57743 5.6876L6.19116 6.2889C6.01717 6.55919 5.72418 6.72147 5.41049 6.72127H2.1297C2.067 6.72141 2.01045 6.76034 1.98606 6.82015C1.96168 6.87997 1.97418 6.94909 2.01782 6.99571L7.64311 12.9913C7.76621 13.1224 7.93529 13.1964 8.11188 13.1964C8.28848 13.1964 8.45756 13.1224 8.58066 12.9913L14.206 6.99571C14.2496 6.94909 14.2621 6.87997 14.2377 6.82015C14.2133 6.76034 14.1568 6.72141 14.0941 6.72127L14.0878 6.71868Z"
        fill="currentFill"
      />
      <path
        d="M15.2093 2.20913C14.6548 1.09445 13.6215 0.319235 12.4259 0.120955C11.2304 -0.0773247 10.015 0.324964 9.15209 1.20459L8.31892 1.99101C8.1996 2.10375 8.01697 2.10375 7.89765 1.99101L7.06448 1.20459C6.2016 0.324964 4.98621 -0.0773247 3.79063 0.120955C2.59505 0.319235 1.56176 1.09445 1.00729 2.20913C0.550884 3.14009 0.482447 4.22396 0.817908 5.20854C0.861672 5.33818 0.979681 5.4251 1.1123 5.42537H5.07875C5.18328 5.42531 5.28086 5.37114 5.33877 5.28103L6.00255 4.2493C6.1888 3.95529 6.51546 3.79037 6.85385 3.81952C7.1916 3.84596 7.48931 4.059 7.63264 4.37681L8.85833 7.09983C8.88371 7.15752 8.93929 7.19455 9.00052 7.19455C9.06175 7.19455 9.11733 7.15752 9.14272 7.09983L9.61399 5.99949C9.76455 5.64923 10.1001 5.42352 10.4703 5.42343H15.1024C15.2351 5.42353 15.3534 5.33685 15.3974 5.20724C15.7329 4.22323 15.6649 3.13991 15.2093 2.20913Z"
        fill="currentFill"
      />
    </SVGLoader>
  );
};

export default AviveStatusIcon;
